module.exports = __webpack_public_path__ + "static/img/wdzt1-3.c27dd75.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdzt1-3.png
// module id = 850
// module chunks = 0